import {IStatus} from "@/constants/interface";

export function borrowerOptions (state) {
  return state.borrowerOptions
    .filter(res => res.status === IStatus.enabled)
    .map(({id, idCardNumber, fullName}) =>{
      return {
        label: `${idCardNumber} : ${fullName}`,
        value: id,
        id,
        idCardNumber,
        fullName
      }
    })
}

export function borrowerSearchOptions (state) {
  return state.borrowerOptions
    .filter(res => res.status === IStatus.enabled)
    .map(({id, idCardNumber, studentCode, fullName}) =>{
      return {
        label: `เลขที่บัตรประชาชน: ${idCardNumber}  รหัสนักศึกษา: ${studentCode}  ชื่อ-สกุล: ${fullName}`,
        value: id,
        id,
        idCardNumber,
        studentCode,
        fullName
      }
    })
}

export function borrowerContractOptions (state) {
  return state.borrowerContractOptions
    .filter(res => res.status === IStatus.enabled)
    .map(({id, idCardNumber, studentCode, fullName}) =>{
      return {
        label: `${idCardNumber} : ${fullName}`,
        value: id,
        id,
        idCardNumber,
        studentCode,
        fullName
      }
    })
}

export function suretyOptions (state) {
  return state.suretyOptions
    .filter(res => res.status === IStatus.enabled)
    .map(({id, idCardNumber, fullName}) =>{
      return {
        label: `${idCardNumber} : ${fullName}`,
        value: id,
        id,
        idCardNumber,
        fullName
      }
    })
}

export function suretySearchOptions (state) {
  return state.suretyOptions
    .filter(res => res.status === IStatus.enabled)
    .map(({id, idCardNumber, fullName}) =>{
      return {
        label: `เลขที่บัตรประชาชน: ${idCardNumber} ชื่อ-สกุล: ${fullName}`,
        value: id,
        id,
        idCardNumber,
        fullName
      }
    })
}

export function suretyContractOptions (state) {
  return state.suretyContractOptions
    .filter(res => res.status === IStatus.enabled)
    .map(({id, idCardNumber, fullName}) =>{
      return {
        label: `${idCardNumber} : ${fullName}`,
        value: id,
        id,
        idCardNumber,
        fullName
      }
    })
}

